site.searchDrop = {
	init: function () {
		$('.search-toggler').click(function (e) {
			$('body').toggleClass('open-search');
			$('#q').focus();
			e.stopPropagation();
		});

		$('body').click(function (e) {
			$('body').removeClass('open-search');
		});

		$('.search-closer').click(function (e) {
			$('body').removeClass('open-search');
		});

		$('.search-drop').click(function (e) {
			e.stopPropagation();
		});

		// Close search if escape key is pressed
		$(document).keyup(function (e) {
			if (e.keyCode == 27) {
				$('body').removeClass('open-search');
			}
		});
	}
};

site.inits.push('site.searchDrop.init()');
